<ng-container *ngIf="!isDateRange">
  <div class="Select">
    <select [disabled]="disabled"
            [ngClass]="{'LargeSize': largeSize, 'Centered': textCentered}"
            [ngModel]="selection"
            (ngModelChange)="onModelChange($event)">
      <option *ngFor="let option of options" [value]="option.value">
        {{ option.labelKey ? (option.labelKey | translate) : option.label }}
      </option>
    </select>
    <div class="Select__Arrow">
    </div>
  </div>
</ng-container>
<ng-container *ngIf="isDateRange">
  <div class="Select">
    <span [title]="options[0].labelKey ? (options[0].labelKey | translate) : options[0].label">
      {{ options[0].labelKey ? (options[0].labelKey | translate) : options[0].label }}
    </span>
    <div class="Select__Arrow">
    </div>
  </div>
</ng-container>
